'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Zeit = function Zeit(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ['color', 'size']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 226.777 226.777',
      fill: color
    }, otherProps),
    _react2.default.createElement('path', { d: 'M173.112 16.995C155.766 6.225 135.305 0 113.387 0c-6.074 0-12.037.483-17.854 1.403l77.578 77.32V16.995zM223.78 87.46c-4.649-19.881-14.716-38.75-30.215-54.25a114.29 114.29 0 0 0-13.615-11.631l.182 109.527L223.78 87.46zm1.593 8.075l-77.317 77.578h61.728c10.769-17.346 16.993-37.808 16.994-59.725a114.441 114.441 0 0 0-1.405-17.853zM139.319 223.78c19.879-4.649 38.749-14.716 54.247-30.214a114.396 114.396 0 0 0 11.633-13.616l-109.53.183 43.65 43.647zm-85.655-13.998c17.345 10.771 37.806 16.995 59.726 16.995a114.34 114.34 0 0 0 17.853-1.403l-77.578-77.319v61.727zM2.997 139.32c4.648 19.878 14.715 38.747 30.214 54.246a114.488 114.488 0 0 0 13.616 11.633l-.183-109.53L2.997 139.32zm13.997-85.655C6.226 71.009 0 91.47 0 113.389c.001 6.074.483 12.036 1.403 17.854l77.32-77.578H16.994zM87.459 2.997c-19.88 4.651-38.75 14.715-54.25 30.213a114.549 114.549 0 0 0-11.63 13.617l109.527-.184L87.459 2.997zM99.474 64.58c2.954 0 13.218-4.355 21.83-6.211a56.165 56.165 0 0 0-7.917-.567 55.324 55.324 0 0 0-26.893 6.932c5.435-.557 10.952-.154 12.98-.154zm38.587 88.701c-2.767 1.384-7.84 8.147-10.453 9.685-1.728 1.018-2.851 3.644-4.169 5.091 20.341-3.717 36.819-18.495 42.951-37.882-.169-.666-.49-1.324-1.304-1.643-2.338-.924-3.812 1.845-6.118-1.538-2.306-3.382.462-10.76 2.46-12.387 1.998-1.623 1.845-6.984 1.366-9.137-.479-2.151.632-4.149 1.862-4.611 1.229-.461-.461-2.614-1.537-4.15s-4.196-6.442-1.845-7.225c.764-.255 1.894.513 3.157 1.872a55.662 55.662 0 0 0-12.747-18.241c-.178 1.821-1.608 3.28-3.63 3.229-2.921-.072-1.538 4.685-4.46 5.761-2.921 1.076-5.226-11.53-5.996-14.297-.768-2.767-6.916-6.148-9.684-4.457-2.769 1.69 5.072 7.07 5.688 9.377.615 2.306-1.845 7.84-1.383 10.762.461 2.92 5.227 8.301 5.073 10.608-.154 2.305-4.46.153-4.766 1.439-.308 1.287-4.306 1.327-7.073 1.021-2.767-.31.155 2.766-3.074 3.535-3.229.768-6.918 7.839-8.993 9.224-2.074 1.383.999 6.456.847 8.762-.154 2.308 5.688 1.846 7.378 3.689 1.69 1.846-3.844 1.076-6.61-.153-2.767-1.229-5.227-3.383-3.535-4.766 1.69-1.383-.308-3.689-4.305-5.38-3.996-1.692-9.532 1.691-9.532 5.995 0 4.305 2.615 4.459 6.151 1.999 3.534-2.46-1.385 3.844 3.381 4.92 4.766 1.074 0 3.228 3.537 5.688 3.536 2.46 6.917-2.152 13.527-1.076 6.611 1.076 10.915 5.535 12.299 7.841s9.069 1.076 10.147 3.997c1.077 2.919-5.842 11.066-8.61 12.448z' }),
    _react2.default.createElement('path', { d: 'M57.802 113.388c0 30.699 24.887 55.587 55.586 55.587 2.36 0 4.686-.149 6.969-.434-1.702-1.473-1.268-5.837-.589-11.263.769-6.149-2.767-6.764-6.687-11.068-3.921-4.306-1.153-7.688.307-9.686 1.461-1.998-.693-3.69-3.305-4.458-2.614-.77-2.305-2.921-4.305-4.305-1.997-1.383-2.921-1.23-10.244-3.997-7.321-2.766-3.284-3.381-8.818-9.147-5.534-5.765-7.379-15.142-4.783-19.293 2.597-4.151-.137-7.225-.751-9.685-.615-2.46 3.689-3.382.461-8.222-3.229-4.838-5.535 3.148-7.84 3.148-1.271 0-1.141-2.847-.769-5.403-9.44 9.963-15.232 23.419-15.232 38.226z' })
  );
};

Zeit.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Zeit.defaultProps = {
  color: 'currentColor',
  size: '24'
};

exports.default = Zeit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-cryptocoins/dist/icons/ZEIT.js
// module id = 1596
// module chunks = 0